'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiLocation = function TiLocation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.4 8.8c-5.2-5.1-13.6-5.1-18.8 0-5.2 5.2-5.2 13.5 0 18.6l9.4 9.3 9.4-9.3c5.2-5.1 5.2-13.4 0-18.6z m-9.4 13.7c-1.1 0-2.2-0.4-2.9-1.2-1.7-1.6-1.7-4.3 0-5.9 0.7-0.8 1.8-1.2 2.9-1.2s2.2 0.4 2.9 1.2c1.7 1.6 1.7 4.3 0 5.9-0.7 0.8-1.8 1.2-2.9 1.2z' })
        )
    );
};

exports.default = TiLocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/location.js
// module id = 3673
// module chunks = 0